import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useDigitalAccountingAccess } from '@ibk/contabilidade-digital';
import { useGetHomePermissions } from '@ibk/shared-permissioning';
import { Loading } from '@ibk/shared-ui';
export function ContabilidadeDigitalAccessGuard({ children }) {
    const { isResolved, hasPermission } = useDigitalAccountingAccess();
    const { hasClientPortalViewPermission } = useGetHomePermissions();
    const isResolvingClientPortalAccess = hasClientPortalViewPermission === undefined;
    if (!isResolved || isResolvingClientPortalAccess) {
        return _jsx(Loading, { fullScreen: true });
    }
    if (!hasPermission && !hasClientPortalViewPermission) {
        return _jsx(Navigate, { to: '/home', replace: true });
    }
    return _jsx(React.Fragment, { children: children });
}
